'use client';

import {
  HighlightBanner1Button,
  HighlightSection as HighlightSectionUI,
  HightlightBannerLayout,
  HomeBannerFooter,
} from '@wwe-portal/ui/features/dashboard-revamp/highlight';
import { FC, Fragment, useMemo } from 'react';
import { HighLightData } from '@wwe-portal/entities/dashboard.type';
import Image from 'next/image';
import { UserBannerPip } from './user-banner-pip';
import { HighlightLink } from './highlight-link';

const getBannerType = (type: string) => {
  if (type === 'SINGLE_ONE') {
    return 'single-1';
  }
  return 'single-2';
};

const sizesByType = {
  'single-1':
    '100vw, (min-width: 768px) 50vw, (min-width: 1280px) 30vw, (min-width: 1440px) 25vw',
  'single-2':
    '50vw, (min-width: 768px) 25vw, (min-width: 1280px) 15vw, (min-width: 1440px) 12vw',
};

export const DashboardHighlightSection: FC<{ data: HighLightData[] }> = ({
  data,
}) => {
  const indexAccumulate = useMemo(() => {
    const result: number[] = [];
    for (const group of data) {
      const last = result[result.length - 1];
      result.push((last ?? 0) + group.items.length);
    }
    return result;
  }, [data]);

  return (
    <div>
      <div className="mt-10 flex flex-col gap-3">
        <HighlightSectionUI>
          {data.map((section, indexItem) => {
            const type = getBannerType(section.type);
            return (
              <Fragment key={section.type}>
                {section.items.map((item, indexSection) => {
                  const actualIndex =
                    (indexAccumulate[indexItem - 1] ?? 0) + indexSection;

                  return (
                    <HightlightBannerLayout
                      highlight={indexSection === 0 && indexItem === 0}
                      key={actualIndex}
                      pip={<UserBannerPip item={item} />}
                      type={type}
                      banner={
                        <HighlightLink
                          className="absolute inset-0"
                          item={item}
                          index={actualIndex}
                        >
                          <Image
                            src={item.bannerUrl}
                            alt={item.title}
                            fill
                            className="absolute inset-0 object-cover"
                            sizes={sizesByType[type]}
                          />
                        </HighlightLink>
                      }
                      footer={
                        <HighlightLink item={item} index={actualIndex}>
                          <HomeBannerFooter
                            type={type}
                            description={item.title}
                            button={
                              <HighlightBanner1Button>
                                {item.buttonTitle}
                              </HighlightBanner1Button>
                            }
                          />
                        </HighlightLink>
                      }
                    />
                  );
                })}
              </Fragment>
            );
          })}
        </HighlightSectionUI>
      </div>
    </div>
  );
};
